import { __decorate, __metadata } from 'tslib';
import { Injectable, NgModule } from '@angular/core';
import { ApiService, UiBsOauthModule } from '@wlp/ui-bs-oauth';
import { map, catchError } from 'rxjs/operators';
import { of } from 'rxjs';

const SPE_J_CASH_OUT = '/spe-j-cash-out';
let SpeJCashOut = class SpeJCashOut {
    constructor(api) {
        this.api = api;
    }
    paymentRecharge(body) {
        const uri = `${SPE_J_CASH_OUT}/api/phone-recharge`;
        return this.api.post(uri, body, body.uuidAccountPayment).pipe(map((result) => {
            if (result !== null && result !== undefined) {
                return result;
            }
            throw 'Houve um erro ao buscar os dados!';
        }), catchError((err) => {
            return of(err);
        }));
    }
};
SpeJCashOut = __decorate([
    Injectable(),
    __metadata("design:paramtypes", [ApiService])
], SpeJCashOut);

const SPE_VIEW_N_CELL_PHONE_RECHARGE = '/spe-view-n-cell-phone-recharge';
let SpeViewNCellPhoneRecharge = class SpeViewNCellPhoneRecharge {
    constructor(api) {
        this.api = api;
    }
    getOperators(uuidAccountPayment, phoneNumber, ddd) {
        const uri = `${SPE_VIEW_N_CELL_PHONE_RECHARGE}/v1/list-active-operators/account-payment/${uuidAccountPayment}/phone-number/${phoneNumber}/ddd/${ddd}`;
        return this.api.get(uri).pipe(map((result) => {
            if (result !== null && result !== undefined) {
                return result;
            }
            throw 'Houve um erro ao buscar os dados!';
        }), catchError((err) => {
            return of(err);
        }));
    }
    checkRecharge(uuidAccountPayment, receiptId) {
        const uri = `${SPE_VIEW_N_CELL_PHONE_RECHARGE}/v1/check-recharge-voucher/account-payment/${uuidAccountPayment}/receiptId/${receiptId}`;
        return this.api.get(uri).pipe(map((result) => {
            if (result !== null && result !== undefined) {
                return result;
            }
            throw 'Houve um erro ao buscar os dados!';
        }), catchError((err) => {
            return of(err);
        }));
    }
    consultProductsByOperator(uuidAccountPayment, phoneNumber, ddd, operatorId, historicId, nsu) {
        const uri = `${SPE_VIEW_N_CELL_PHONE_RECHARGE}/v1/consult-products-by-operator/account-payment/${uuidAccountPayment}/phone-number/${phoneNumber}/ddd/${ddd}/operatorId/${operatorId}/historicId/${historicId}/${nsu}`;
        return this.api.get(uri).pipe(map((result) => {
            if (result !== null && result !== undefined) {
                return result;
            }
            throw 'Houve um erro ao buscar os dados!';
        }), catchError((err) => {
            return of(err);
        }));
    }
};
SpeViewNCellPhoneRecharge = __decorate([
    Injectable(),
    __metadata("design:paramtypes", [ApiService])
], SpeViewNCellPhoneRecharge);

let UiPxRechargePhoneModule = class UiPxRechargePhoneModule {
};
UiPxRechargePhoneModule = __decorate([
    NgModule({
        declarations: [],
        imports: [
            UiBsOauthModule
        ],
        providers: [
            SpeJCashOut,
            SpeViewNCellPhoneRecharge
        ]
    })
], UiPxRechargePhoneModule);

export { SpeJCashOut, SpeViewNCellPhoneRecharge, UiPxRechargePhoneModule };
//# sourceMappingURL=wlp-ui-px-recharge-phone.js.map
